// extracted by mini-css-extract-plugin
module.exports = {"title":"Report_title__2dy9n","name":"Report_name__K7xNZ","employeeReport":"Report_employeeReport__C3t4s"};